import React from "react";
import { arrayOf, shape, string, func } from "prop-types";
import AutocompleteDropdownGroupLabel from "@insightfulscience/atomic-react/Autocomplete/DropdownGroupLabel";
import AutocompleteDropdownItem from "@insightfulscience/atomic-react/Autocomplete/DropdownItem";
import AutocompleteDropdownItemLink from "@insightfulscience/atomic-react/Autocomplete/DropdownItemLink";
import AutocompleteDropdownGroup from "@insightfulscience/atomic-react/Autocomplete/DropdownGroup";
import NextLink from "@insightfulscience/smart-react/NextLink";
import { correctPlasmidName, routePlasmid } from "../../utils/plasmid/helpers";

const ResultItem = ({ sequences, setData, onItemSelected, ...props }) =>
	sequences.length > 0 ? (
		<AutocompleteDropdownGroup {...props}>
			<AutocompleteDropdownGroupLabel
				dangerouslySetInnerHTML={{ __html: setData.plasmidSetName }}
			/>
			{sequences.map(sequence => {
				return (
					<AutocompleteDropdownItem key={sequence.plasmidName}>
						<NextLink
							Component={AutocompleteDropdownItemLink}
							onClick={onItemSelected}
							href={routePlasmid(setData.set, sequence.plasmidID)}
						>
							{correctPlasmidName(sequence)}
						</NextLink>
					</AutocompleteDropdownItem>
				);
			})}
		</AutocompleteDropdownGroup>
	) : null;

ResultItem.propTypes = {
	setData: shape({
		set: string.isRequired,
		plasmidSetName: string.isRequired,
	}),
	sequences: arrayOf(
		shape({
			plasmidID: string.isRequired,
			plasmidName: string.isRequired,
		}),
	),
	onItemSelected: func,
};

export default ResultItem;
